import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/list.jsx';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false
        };

        this.crefs = {};

        this.toggleModal = this.toggleModal.bind(this);

        return this;
    }

    toggleModal(type) {
        this.setState({
            showModal: !this.state.showModal,
            cardType: typeof type === 'string' ? type : ''
        });
    }

    static displayName = 'CardsList';

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
